/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
		$('.layout-select').select2({
			dropdownAutoWidth : true,
    		width: 'auto',
			minimumResultsForSearch: -1
		});
		
		function initNavbarToggle(){
			$('.navbar-toggle').unbind('click');
			$('.navbar-toggle').click(function(){
				var window_height = $(window).height();
				var header_height = $('.navbar-header').height();
											   
				if($(this).hasClass('collapsed')){
					$(this).removeClass('collapsed');
					$('body').removeClass('no-scroll');
					$('.mobile-menu-wrapper').css('height', 'auto');
					//$('.menu-main-menu-container').css('height', 'auto');
				}else{
					$(this).addClass('collapsed');
					$('body').addClass('no-scroll');
					$('.mobile-menu-wrapper').css('height', window_height-header_height);
					//$('.menu-main-menu-container').css('height', window_height-header_height);
				}
			});
			
			$('.menu-item-has-children > a').click(function(e){
				e.preventDefault();
				if($(this).parent().hasClass('opened')){
					$(this).parent().removeClass('opened');
				}else{
					$(this).parent().addClass('opened');
				}
			});
			
			$('.has-children > a').click(function(e){
				e.preventDefault();
				if($(this).parent().hasClass('opened')){
					$(this).parent().removeClass('opened');
				}else{
					$(this).parent().addClass('opened');
				}
			});
		}
		
		function initLogin(){
			$('.icon_lock').click(function(){
				$('.login_panel').css({'height':$(window).height()-$('header').height(), 'top':$('header').height()}).fadeIn();
				$('body').addClass('no-scroll');
			});
			
			$('.btn_login_close').click(function(){
				$('.login_panel').fadeOut();
				$('body').removeClass('no-scroll');
			});
			
			$(window).resize(function(){
				$('.login_panel').css({'height':$(window).height()-$('header').height(), 'top':$('header').height()});					  
			});
		}
		
		function initSearch(){
			$('.icon_search').click(function(){
				if($('.search-container').hasClass('show')){
					$('.search-container').not('.search_page').removeClass('show').fadeOut();
				}else{
					$('.search-container').not('.search_page').addClass('show').fadeIn();
				}
			});
			
			/*$('.search-field').on('keypress',function(e) {
			   var keycode = event.keyCode || event.which;
			   //console.log(keycode);
			   console.log(e.key);
			   if(keycode == '13') {
			   	alert('You pressed a "enter" key in somewhere');    
			   }
			});*/
			
			$('.search-field').keypress(function (e) {
			  if (e.which == 13) {
				$('form.search-form').submit();
				return false;    //<---- Add this line
			  }
			});
			
			$('#s3').keypress(function (e) {
			  if (e.which == 13) {
				$('form.searchform').submit();
				return false;    //<---- Add this line
			  }
			});
		}
		
		function gotoLink(url){
			var uagent = navigator.userAgent.toLowerCase();
			if(/safari/.test(uagent) && !/chrome/.test(uagent)) {
				window.location.href = url;
			}else{
				window.location.assign(url);
			}
		}
		
		function tw_f_login(loginName, loginPassword, errorMessage) {
			var ls_param = JSON.stringify({"as_user_login" : $("#"+loginName).val(), "as_password" : $("#"+loginPassword).val() });
			
			$.ajax({ 
				type: "POST", 
				url: "https://trakwizard3.weconnor.com/wwweb_tw/UserLoginWebSvc.asmx/RemoteLogin",
				xhrFields: {
					withCredentials: true
				}, 
				crossDomain: true, 
				data: ls_param, 
				contentType: "application/json; charset=utf-8", 
				dataType: "json", 
				cache: false, 
				success: function(as_result) {
					//var lo_result = $.evalJSON(as_result);
					var lo_result = $.parseJSON(as_result);
					
					if (lo_result.result === "OK") {
						if (lo_result.tfa_status === "N"){
							window.location.assign("https://trakwizard3.weconnor.com/wwweb_tw/TfaRedirector.aspx?website=HOME&page=wecMain.asp&refresh_all=Y");
						} else if (lo_result.tfa_status === "Y") {
							window.location.assign("https://trakwizard3.weconnor.com/wwweb_tw/tfaVerify.aspx?newjqgridyn=y");
						} else if (lo_result.tfa_status === "R") {
							window.location.assign("https://trakwizard3.weconnor.com/wwweb_tw/TfaRedirector.aspx?website=HOME&page=wecMain.asp&refresh_all=Y&show_tfa_reminder_yn=Y");
						} else if (lo_result.tfa_status === "F") {
							window.location.assign("https://trakwizard3.weconnor.com/wwweb_tw/TfaRedirector.aspx?website=HOME&page=wecPerSetting.asp&force_tfa_yn=Y");
						}
					} else if (lo_result.result === "OKEXP") {
						if (lo_result.tfa_status === "N"){
							window.location.assign("https://trakwizard3.weconnor.com/wwweb_tw/TfaRedirector.aspx?website=HOME&page=wecChangePassword.asp");
						} else if (lo_result.tfa_status === "Y") {
							window.location.assign("https://trakwizard3.weconnor.com/wwweb_tw/tfaVerify.aspx?newjqgridyn=y");
						} else if (lo_result.tfa_status === "R" || lo_result.tfa_status === "F") {
							window.location.assign("https://trakwizard3.weconnor.com/wwweb_tw/TfaRedirector.aspx?website=HOME&page=wecChangePassword.asp&tfa_status="+lo_result.tfa_status);
						}
					} else {
						var ls_err_msg = "Invalid login credentials.<br>Please try again.";
						$('#'+errorMessage).html(ls_err_msg);
					}
				}, error: function(XMLHttpRequest, textStatus, errorThrown) {
					$('#'+errorMessage).html(XMLHttpRequest.responseText);
				}
			});
		}
		
		function tw_forgot_password(loginName, loginEmail, errorMessage) {
			var ls_param = JSON.stringify({"as_user_login" : $("#"+loginName).val(), "as_email" : $("#"+loginEmail).val() });
			$.ajax({ 
				type: "POST",
				url: "https://trakwizard3.weconnor.com/wwweb_tw/UserLoginWebSvc.asmx/RemoteForgetPwd",
				xhrFields: {
					withCredentials: true
				},
				crossDomain: true,
				data: ls_param,
				contentType: "application/json; charset=utf-8",
				dataType: "json",
				cache: false,
				success: function(as_result) {
					if (as_result === "OK") {
						$("#"+errorMessage).html("A new password will be sent to your email address in a few minutes");
					} else {
						$("#"+errorMessage).html(as_result);
					}
				},
				error: function(XMLHttpRequest, textStatus, errorThrown) {
					$("#"+errorMessage).html(XMLHttpRequest.responseText);
				}
			});
		}
		  
		function sc_f_login(loginName, loginPassword, errorMessage) {
			var ls_param =  JSON.stringify({"as_user_login" : $("#"+loginName).val(), "as_password" : $("#"+loginPassword).val() });
			$.ajax({ 
				type: "POST",
				url: "https://supplierconnect.weconnor.com/wwweb_sc/scUserws.asmx/RemoteLogin",
				xhrFields: {
					withCredentials: true
				},
				crossDomain: true,
				data: ls_param,
				contentType: "application/json; charset=utf-8",
				dataType: "json",
				cache: false,
				success: function(as_result) {
					if (as_result === "OK") {
						//success
						window.location.assign("https://supplierconnect.weconnor.com/wwweb_sc/Sc2Redirector.aspx?website=SCPUBNET1&page=../scEcopMain.aspx");
					} else if (as_result === "OKEXP") {
						window.location.assign("https://supplierconnect.weconnor.com/wwweb_sc/Sc2Redirector.aspx?website=SCPUBNET1&page=../scChangePassword.aspx&fr=LOGIN&display=1&disMsg=2");
					} else {
						var ls_err_msg = "Invalid login credentials.<br>Please try again."
						$("#"+errorMessage).html(ls_err_msg);
					}
				},
				error: function(XMLHttpRequest, textStatus, errorThrown) {
					$("#"+errorMessage).html(XMLHttpRequest.responseText);
				}
			});
		}
		
		function sc_forgot_password(loginName, loginEmail, errorMessage) {
			var ls_param =  JSON.stringify({"as_user_login" : $("#"+loginName).val(), "as_email" : $("#"+loginEmail).val() });
			$.ajax({
				type: "POST",
				url: "https://supplierconnect.weconnor.com/wwweb_sc/scUserws.asmx/RemoteForgetPwd",
				xhrFields: {
				 withCredentials: true
				},
				crossDomain: true,
				data: ls_param,
				contentType: "application/json; charset=utf-8",
				dataType: "json",
				cache: false,
				success: function(as_result) {
				  if (as_result === "OK") {
					$("#"+errorMessage).html("A new password will be sent to your email address in a few minutes");
				  } else {
					$("#"+errorMessage).html(as_result);
				  }
				},
				error: function(XMLHttpRequest, textStatus, errorThrown) {
				  $("#"+errorMessage).html(XMLHttpRequest.responseText);
				}
			});
		}
		
		function show_forgot_password(loginContainer, fPasswordContainer, formToShowID){
			$('.'+loginContainer).hide();
			$('.'+fPasswordContainer).show();
			$('.forget_password_form').hide();
			$("#"+formToShowID).show();
		}
		
		function show_login_form_desktop(){
			$('.login_container').show();
			$('.forget_password_container').hide();
			$('.forget_password_form').hide();	
		}
		
		function show_login_form_mobile(obj){
			$('.forgot_pw_form_mobile').hide();
			$('.login_form_mobile').hide();
			$('#'+$(obj).data('target')).show();	
		}
		
		$(document).ready(function(){
			$(".btn-back-to-top").hide();
			
			$('form input').keydown(function (e) {
				if (e.keyCode == 13) {
					e.preventDefault();
					return false;
				}
			});
			
			$(function () {
				$(window).scroll(function () {
					if ($(this).scrollTop() > 100) {
						$('.btn-back-to-top').fadeIn();
					} else {
						$('.btn-back-to-top').fadeOut();
					}
				});
		
				// scroll body to 0px on click
				$('.btn-back-to-top').click(function () {
					$('body,html').animate({
						scrollTop: 0
					}, 800);
					return false;
				});
			});
			
			initNavbarToggle();
			
			//$('img[usemap]').rwdImageMaps();
			$('map').imageMapResize();
			
			about_pie_init();
			
			apparel_pie_init();
			
			home_pie_init();
			
			initLogin();
			
			initSearch();
			
			$('#tw_login').click(function(e){
			    e.preventDefault();
				tw_f_login('twloginName', 'twpassword', 'tw_login_err_message');
			});
			
			$('#btn-get-possword-tw').click(function(e){
				e.preventDefault();
				tw_forgot_password('twloginName2', 'twemail', 'tw_forget_err_message');
			});
			
			$('#forget_password_form_tw').click(function(){
				show_forgot_password('login_container', 'forget_password_container', 'twForm2');
			});
			
			$('#btn-cancel-tw').click(function(){
				show_login_form_desktop();
			});
			
			$('#btn-login-sc').click(function(e){
				e.preventDefault();
				sc_f_login('scloginName', 'scpassword', 'sc_login_err_message');
		    });
			
			$('#btn-get-possword-sc').click(function(e){
			    e.preventDefault();
				sc_forgot_password('scloginName2', 'scemail', 'sc_forget_err_message') 
		    });
			
			$('#forget_password_form_sc').click(function(){
				show_forgot_password('login_container', 'forget_password_container', 'scForm2');
		    });
			
			$('#btn-cancel-sc').click(function(){
				show_login_form_desktop();
		    });
			
			$('#tw_login_popup').click(function(e){
				e.preventDefault();
				tw_f_login('twloginName_popup', 'twpassword_popup', 'tw_login_err_message_popup');
			});
			
			$('#btn-get-possword-tw_popup').click(function(e){
				e.preventDefault();
				tw_forgot_password('twloginName2_popup', 'twemail_popup', 'tw_forget_err_message_popup');
			});
			
			$('#forget_password_form_tw_popup').click(function(e){
				e.preventDefault();
				show_forgot_password('login_container', 'forget_password_container', 'twForm2_popup');
			});
			
			$('#btn-cancel-tw_popup').click(function(e){
				e.preventDefault();
				show_login_form_desktop();
			});
			
			$('#btn-login-sc_popup').click(function(e){
				e.preventDefault();
				sc_f_login('scloginName_popup', 'scpassword_popup', 'sc_login_err_message_popup');
		    });
			
			$('#btn-get-possword-sc_popup').click(function(e){
				e.preventDefault();
				sc_forgot_password('scloginName2_popup', 'scemail_popup', 'sc_forget_err_message_popup') 
		    });
			
			$('#forget_password_form_sc_popup').click(function(e){
				e.preventDefault();
				show_forgot_password('login_container', 'forget_password_container', 'scForm2_popup');
		    });
			
			$('#btn-cancel-sc_popup').click(function(e){
				e.preventDefault();
				show_login_form_desktop();
		    });
			
			$('.mobile_login').each(function(){
				$(this).click(function(e){
					e.preventDefault();
					$('.forgot_pw_form_mobile').hide();
					$('.login_form_mobile').hide();					
					$('#'+$(this).data('target')).show();
				});
			});
			
			$('.forgot_pw_link').each(function(){
				$(this).click(function(e){
					e.preventDefault();
					$('.login_form_mobile').hide();
					$('#'+$(this).data('target')).show();
				});
			});
			
			$('.f_pw_cancel').each(function(){
				$(this).click(function(e){
					e.preventDefault();
					show_login_form_mobile($(this));
					
					/*$('.forgot_pw_form_mobile').hide();
					$('.login_form_mobile').hide();
					$('#'+$(this).data('target')).show();*/
				});
			});
	    });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
		
		  
        function initSlick(){
			var time = 5;
			var $bar,
				$slick,
				isPause,
				tick,
				percentWidth;
				
			var totalSlider = $('.hero-banner-item').length;
			
			$bar = $('.slider-progress .progress');
			$slick = $('.hero-banner-container');
			
			$slick.on('init', function() {
				var dataId = parseInt($('.slick-current').attr("data-slick-index"))+1;
				
				percentWidth = (dataId/totalSlider)*100;
				
				$bar.css({
					width: percentWidth+"%"
				});				
			});
			
			$slick.slick({
				dots: false,
				autoplay: true,
				autoplaySpeed: 5000,
				slidesToScroll: 1,
				slidesToShow: 1,
				mobileFirst: true,
				pauseOnDotsHover: true,
				prevArrow: $('.prev'),
				nextArrow: $('.next')
			});
			
			$slick.on('afterChange', function() {
				var dataId = parseInt($('.slick-current').attr("data-slick-index"))+1;
				
				percentWidth = (dataId/totalSlider)*100;
				
				$bar.css({
					width: percentWidth+"%"
				});
			});
			
			
			
			/*$('.hero-banner-wrapper').on({
				mouseenter: function() {
					isPause = true;
				},
				touchstart: function() {
					isPause = true;
				},
				mouseleave: function() {
					isPause = false;
					startProgressbar();
				},
				touchend: function() {
					isPause = false;
					startProgressbar();
				}
			});
			
			function interval() {
				if(isPause === false) {
					percentTime += 1 / (time+0.1);
					$bar.css({
					width: percentTime+"%"
				});
					
				if(percentTime >= 100)
					{
					  $slick.slick('slickNext');
					  startProgressbar();
					}
				}
			}
			
			function startProgressbar() {
				resetProgressbar();
				percentTime = 0;
				isPause = false;
				tick = setInterval(interval, 10);
			}
			
			function resetProgressbar() {
				$bar.css({
					width: 0+'%' 
				});
				clearTimeout(tick);
			}
			
			startProgressbar();*/
		}
		
		function initMobileBannerHeight(){
			bannerHeight = $(window).height()-$('.header-wrapper').height();
			
			if($(window).width() < 992){
				$('.mobile-banner').css('height', bannerHeight);	
			}else{
				$('.desktop-banner').css('height', bannerHeight);	
			}
		}
			
		// JavaScript to be fired on the home page
		$(document).ready(function(){			
			/*$('#map .map-point').each(function(){
				$(this).click(function(){
					$(this).addClass('show');
				});	
				
				$(this).find('.popup').click(function(){
					if($(this).parent().hasClass('show')){
						$(this).parent().removeClass('show');	
					}
				});
			});
			
			$('body').on('click',function(event){
			   if(!$(event.target).is('.map-point')){
				 $(".map-point").removeClass("show");
			   }
			});*/
								   
			initSlick();
			initMobileBannerHeight();
			
		});
		
		$(window).resize(function(){
			initMobileBannerHeight();						  
		});
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    // About us page, note the change from about-us to about_us.
    'page_template_template_global_network': {
      init: function() {
        // JavaScript to be fired on the about us page
		function initOfficeList(){
			var office = getUrlParameter('office');
			console.log(office);
			
			$('.office_list_expandable li').each(function(){
				$(this).find('a').click(function(){
					$('.office_list_expandable li').removeClass('active');
					$(this).parent().addClass('active');
				});
			});
			
			$('.map-point .popup a').each(function(){
				$(this).click(function(e){
					e.preventDefault(); 
					var fid = $(this).attr("href");
					var itemId = fid.substring(1, fid.length);
					console.log(itemId);
					list_item_trigger(itemId);
					$("html, body").stop(true, false).animate({ scrollTop: $('#'+itemId).offset().top-50 }, 1000);
			    });
			});
			
			function list_item_trigger(id){
				console.log(id);
				$('.office_list_expandable li').removeClass('active');
				$('#'+id).addClass('active');
			}
			
			if(office){
				list_item_trigger(office);
				$("html, body").stop(true, false).animate({ scrollTop: $('#'+office).offset().top-50 }, 1000);
			}else{
				$('.office_list_expandable li').eq(0).addClass('active');		
			}
			
			
		}
				
		function new_map( $el ) {
			
			// var
			var $markers = $el.find('.marker');
			
			
			// vars
			var args = {
				zoom		: 16,
				center		: new google.maps.LatLng(0, 0),
				mapTypeId	: google.maps.MapTypeId.ROADMAP
			};
			
			
			// create map	        	
			var map = new google.maps.Map( $el[0], args);
			
			
			// add a markers reference
			map.markers = [];
			
			
			// add markers
			$markers.each(function(){
				
				add_marker( $(this), map );
				
			});
			
			
			// center map
			center_map( map );
			
			
			// return
			return map;
			
		}
		
		function add_marker( $marker, map ) {
		
			// var
			var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
		
			// create marker
			var marker = new google.maps.Marker({
				position	: latlng,
				map			: map
			});
		
			// add to array
			map.markers.push( marker );
		
			// if marker contains HTML, add it to an infoWindow
			if( $marker.html() )
			{
				// create info window
				var infowindow = new google.maps.InfoWindow({
					content		: $marker.html()
				});
		
				// show info window when marker is clicked
				google.maps.event.addListener(marker, 'click', function() {
		
					infowindow.open( map, marker );
		
				});
			}
		
		}
		
		function center_map( map ) {
		
			// vars
			var bounds = new google.maps.LatLngBounds();
		
			// loop through all markers and create bounds
			$.each( map.markers, function( i, marker ){
		
				var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
		
				bounds.extend( latlng );
		
			});
		
			// only 1 marker?
			if( map.markers.length === 1 )
			{
				// set center of map
				map.setCenter( bounds.getCenter() );
				map.setZoom( 16 );
			}
			else
			{
				// fit to bounds
				map.fitBounds( bounds );
			}
		
		}
		
		var map = null;
		
		$(document).ready(function(){
			initOfficeList();
			
			$('.acf-map').each(function(){
		
				// create map
				map = new_map( $(this) );
		
			});
		});
      }
    },
    // About us page, note the change from about-us to about_us.
    'page_template_template_news': {
      init: function() {
		var year_select;
		var first_load = true;
		
		if(last_post){
			$('.loadmore').hide();	
		}else{
			$('.loadmore').show();	
		}
		  
		function getNews(){
			var ajaxurl = '/wp-admin/admin-ajax.php';
			
			var data = {
				'action': 'news_loading',
				'page': paged,
				'year_var': year_select
			};
	
			// since 2.8 ajaxurl is always defined in the admin header and points to admin-ajax.php
			$.post(ajaxurl, data, function(response) {
				//alert('Got this from the server: ' + response);
				if(year_select !== '' && first_load){
					$('.post-container').html('').append(response);
					first_load = false;
					paged++;
				}else if(year_select === 'all' && first_load){
					$('.post-container').html('').append(response);
					first_load = false;
					paged++;
			    }else{
					$('.post-container').append(response);
					paged++;
				}
				
				if(last_post){
					$('.loadmore').hide();	
				}else{
					$('.loadmore').show();	
				}
			});
		}
		  
		$('body').on('click', '.loadmore', function() {
			first_load = false;
			//last_post = false;
			getNews();
		});
		
		$('#year_select').on("select2:select", function(e){
			var data = e.params.data;
			year_select = data.id;
			paged = 0;
			first_load = true;
			last_post = false;
			//console.log(year_select);
			if(year_select !== ''){
				getNews();
			}
		});
	  }
	}
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };
  
  var getUrlParameter = function getUrlParameter(sParam) {
	var sPageURL = window.location.search.substring(1),
		sURLVariables = sPageURL.split('&'),
		sParameterName,
		i;
	
	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split('=');
	
		if (sParameterName[0] === sParam) {
			return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
		}
	}
  };
  
  function about_pie_init(){
	var about_map_hover = false;
	var about_counter = 1;
	var about_rotation_timer;
	
	function autoRotation(control){
		
		if(!control){
			about_rotation_timer = setInterval(
				function(){
					$('#about_pie .pie-chart-section img').removeClass('show');
					$('#about_pie .pie-chart-section img').eq(about_counter).addClass('show');
					if(about_counter < $('#about_pie .pie-chart-section img').length-1){
						about_counter++;
					}else{
						about_counter=1;
					}
				},2000
			);
		}else{
			clearInterval(about_rotation_timer);
		}
	}
	
	autoRotation(about_map_hover);
	$('#about_Map area').each(function(){
		$(this).on('mouseover',function(){
			$('#about_pie .pie-chart-section img').removeClass('show');
			$($(this).attr('href')).addClass('show');
			about_counter = $(this).data('pie');
		});
		
		$(this).click(function(e){
			e.preventDefault();
			$('#about_pie .pie-chart-section img').removeClass('show');
			$($(this).attr('href')).addClass('show');
			about_counter = $(this).data('pie');
		});
	});
	
	$('#about_pie .pie-chart-map').on('mouseenter', function(){
		about_map_hover = true;
		autoRotation(about_map_hover);
	});
	
	$('#about_pie .pie-chart-map').on('mouseleave', function(){
		about_map_hover = false;
		autoRotation(about_map_hover);
	});  
  }
  
  function apparel_pie_init(){
	var apparel_map_hover = false;
	var apparel_counter = 1;
	var apparel_rotation_timer;
	
	function autoRotation(control){
		
		if(!control){
			apparel_rotation_timer = setInterval(
				function(){
					$('#apparel_pie .pie-chart-section img').removeClass('show');
					$('#apparel_pie .pie-chart-section img').eq(apparel_counter).addClass('show');
					if(apparel_counter < $('#apparel_pie .pie-chart-section img').length-1){
						apparel_counter++;
					}else{
						apparel_counter=1;
					}
				},2000
			);
		}else{
			clearInterval(apparel_rotation_timer);
		}
	}
	
	autoRotation(apparel_map_hover);
	$('#apparel_Map area').each(function(){
		$(this).hover(function(){
			$('#apparel_pie .pie-chart-section img').removeClass('show');
			$($(this).attr('href')).addClass('show');
			apparel_counter = $(this).data('pie');
		});
		
		$(this).click(function(e){
			e.preventDefault();
			$('#apparel_pie .pie-chart-section img').removeClass('show');
			$($(this).attr('href')).addClass('show');
			apparel_counter = $(this).data('pie');
		});
	});
	
	$('#apparel_pie .pie-chart-map').on('mouseenter', function(){
		apparel_map_hover = true;
		autoRotation(apparel_map_hover);
	});
	
	$('#apparel_pie .pie-chart-map').on('mouseleave', function(){
		apparel_map_hover = false;
		autoRotation(apparel_map_hover);
	});  
  }
			
  function home_pie_init(){
	var home_map_hover = false;
	var home_counter = 1;
	var home_rotation_timer;
	
	function autoRotation(control){
		
		if(!control){
			home_rotation_timer = setInterval(
				function(){
					$('#home_pie .pie-chart-section img').removeClass('show');
					$('#home_pie .pie-chart-section img').eq(home_counter).addClass('show');
					if(home_counter < $('#home_pie .pie-chart-section img').length-1){
						home_counter++;
					}else{
						home_counter=1;
					}
				},2000
			);
		}else{
			clearInterval(home_rotation_timer);
		}
	}
	
	autoRotation(home_map_hover);
	  
	$('#home_Map area').each(function(){
		$(this).hover(function(){
			$('#home_pie .pie-chart-section img').removeClass('show');
			$($(this).attr('href')).addClass('show');
			home_counter = $(this).data('pie');
		});
		
		$(this).click(function(e){
			e.preventDefault();
			$('#home_pie .pie-chart-section img').removeClass('show');
			$($(this).attr('href')).addClass('show');
			home_counter = $(this).data('pie');
		});
	});
	
	$('#home_pie .pie-chart-map').on('mouseenter', function(){
		home_map_hover = true;
		autoRotation(home_map_hover);
	});
	
	$('#home_pie .pie-chart-map').on('mouseleave', function(){
		home_map_hover = false;
		autoRotation(home_map_hover);
	});  
  }
  
  
	
  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
